import FontBody1 from "../../fonts/font-body1/font-body1";
import IconDiscard from "../../icons/icon-discard/icon-discard";
import { ButtonIcon } from "../../inputs/button-icon/button-icon";
import { IShop } from "../../../models/User";
import FontBody3 from "../../fonts/font-body3/font-body3";

interface ISelectedShopProps {
    shop: IShop;
    onUnselect: (shop: IShop) => void;
}

const SelectedShop: React.FC<ISelectedShopProps> = ({ shop, onUnselect }) => {
    return (
        <span className="selected-shop">
            <FontBody1>{shop.name}</FontBody1> <FontBody3>({shop.id})</FontBody3>
            <ButtonIcon
                Component={() => <IconDiscard color="var(--color-neutral-3)" />}
                onClick={() => onUnselect(shop)}
            />
        </span>
    );
}

export default SelectedShop;
